// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/funnel.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'funnel',
  version: 'outline',
  paths: [
    {
      d: 'M22 2.995H2l8 9.461v6.54l4 2v-8.54z',
      strokeWidth: 1.8,
    },
  ],
}
